import request from "@helpers/request";

function fetchLegendList(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/gis/getLegends`, data, { ...config });
}

function createLegend(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/gis/legend`, data, {
      ...config,
    });
}

function deleteLegend(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .delete(`/v1/gis/legend`, data, { ...config });
}

function uploadPropagation(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "multipart/form-data" })
    .build()
    .post(`/v1/gis/propagation`, data, { ...config });
}

const webGISService = {
  fetchLegendList,
  createLegend,
  deleteLegend,
  uploadPropagation,
};

export default webGISService;
